type AppGlobal = {
  appGlobal: { incomeStatement: { cells: Record<string, { value: string }> } };
};

const INCOME_STATEMENT = (cell: string) => {
  const { appGlobal } = window as unknown as AppGlobal;
  const key = cell.replace(/!/g, '');

  if (appGlobal?.incomeStatement?.cells) {
    if (appGlobal.incomeStatement.cells[key]) {
      return appGlobal.incomeStatement.cells[key].value;
    }
  }

  return null;
};

export default INCOME_STATEMENT;
